import {MeasurementData} from '@/views/system/measurements/interfaces';
import {PModuleMeasurement, PModuleMeasurementActive} from '@/views/system/modules/interfaces';

// Обновляем колекцию MeasurementData с заданными границами
export function updateMeasurements(
  measurements: PModuleMeasurement[],
  newEntities: MeasurementData[],
): void {
  if (!Array.isArray(measurements)) {
    return;
  }
  // создаем объекты (из еще не сохраненных измерений) для добавления в коллекцию measurements.
  // По умолчанию isActive = false и isNew = true
  newEntities.forEach((meas: MeasurementData) => {
    const modal: PModuleMeasurementActive = {
      measurementId: meas.id,
      measurementDescription: meas.name,
      topWarningBoundary: meas.topWarningBoundary,
      topDangerBoundary: meas.topDangerBoundary,
      topErrorBoundary: meas.topErrorBoundary,
      bottomWarningBoundary: meas.bottomWarningBoundary,
      bottomDangerBoundary: meas.bottomDangerBoundary,
      bottomErrorBoundary: meas.bottomErrorBoundary,
      isNew: true,
      isActive: false,
    };
    // Добавляем новые объекты в коллекцию
    measurements.push(modal);
  });
}
